import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

// Define the base API
export const projectApi = createApi({
  reducerPath: 'projectApi',
  baseQuery: baseQuery(),
  tagTypes: ['Project'], // Define a tag type for cache invalidation
  endpoints: (builder) => ({
    // list projects API
    listProjects: builder.query({
      query: () => ({
        url: `/project`,
      }),
      providesTags: ['Project'],
    }),
    // create project API
    createProject: builder.mutation({
      query: (body) => ({
        url: `/project`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Project'],
    }),
    // fetch a project by id
    fetchProject: builder.query({
      query: (id) => ({
        url: `/project/${id}`,
      }),
      // without this a rename is invisible after navigating away and back:
      // the detail entry stays cached and feeds the old name to the title editor
      providesTags: ['Project'],
    }),
    // update project API
    updateProject: builder.mutation({
      query: ({ id, name, description }) => ({
        url: `/project/${id}`,
        method: 'PUT',
        body: {
          id,
          ...(name && { name }),
          ...(description && { description })
        },
      }),
      invalidatesTags: ['Project'],
    }),
    // delete project API
    deleteProject: builder.mutation({
      query: (id) => ({
        url: `/project/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Project'],
    }),
    // list soft-deleted (trashed) projects
    listDeletedProjects: builder.query({
      query: () => ({
        url: `/project/deleted`,
      }),
      providesTags: ['Project'],
    }),
    // restore a trashed project
    undoDeleteProject: builder.mutation({
      query: (id) => ({
        url: `/project/${id}/undo-delete`,
        method: 'PUT',
      }),
      invalidatesTags: ['Project'],
    }),
  }),
});

export const {
  useListProjectsQuery,
  useCreateProjectMutation,
  useFetchProjectQuery,
  useUpdateProjectMutation,
  useDeleteProjectMutation,
  useListDeletedProjectsQuery,
  useUndoDeleteProjectMutation,
} = projectApi;

export default projectApi;